/**
 * See also ember-cli-build.js staticAppPaths
 */
import { getOwnConfig, macroCondition } from '@embroider/macros';

export default function(compatModules) {
  // None of this is working, so it's disabled for now. Currently, it's being
  // handled by using macroCondition in `services/*.js` to import from elsewhere.
  if (macroCondition(false && getOwnConfig().isSsrBuild)) {

    function addCompatModules(modulesPath, modules, compatModules, type = 'service') {
      const addedModules = {};
      for (let [ path, resolver ] of Object.entries(modules)) {
        const name = path
          .slice(modulesPath.length)
          .replace(/\.js$/, '')
        ;
        const key = `${type}:${name}`;
        if (compatModules[key]) {
          console.log(`skipping from '${modulesPath}': '${key}'`);
        } else {
          console.log(`importing from '${modulesPath}': '${key}'`);
          resolver = () => import(path);
          compatModules[key] = resolver;
          addedModules[key] = resolver;
        }
      }
      return addedModules;
    }

    const servicesPath = './_services/';
    const services
      = import.meta.glob('./_services/**/*.js');

    const serviceStubsPath = './_ssr-stubs/services/';
    const serviceStubs
      = import.meta.glob('./_ssr-stubs/services/**/*.js');

    const serviceStubModules
      = addCompatModules(serviceStubsPath, serviceStubs, compatModules);
    const serviceModules
      = addCompatModules(servicesPath, services, compatModules);

    // console.log('compatModules', compatModules);
  }
  return compatModules;
}
